<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津国旅海外国际旅游有限责任公司</div>
                  <p class="p1">
                    天津国旅海外国际旅游有限责任公司（天津中国国际旅行社）成立于1954年4月15日，是天津市最早和规模最大的旅行社，曾先后隶属于天津市外事办公室、天津市旅游局，目前是天津市旅游（控股）集团有限公司的全资子公司。
                  </p>

                  <p class="p2">
                    天津国旅经营业务包括：国内旅游、出境旅游、入境旅游、红色教育、研学旅行、工业游、航空客票代理、汽车出租、会议服务、全球酒店预定和商务旅行代理等。
                  </p>
                  <div class="p1">
                    天津国业务资质有：特许经营中国公民出境游许可、航空客运一类、二类代理人、IATA成员、日、韩、台送签权。
                  </div>
                  <div class="p1">天津国旅地址：天津市河西区友谊路22号</div>
                  <div class="p1">公司咨询电话：022-58559988</div>
                  <div class="img1">
                    <img
                      src="@/assets/images/tjgl1.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                    <div class="img1">
                    <img
                      src="@/assets/images/tjgl2.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>